<template>
  <v-container>
    <div class="d-flex justify-space-between">
      <h2 color="#6A158E" class="page-heading" v-text="page_title"></h2>
<!-- {{ permitObj }} -->
      <bread-crumbs :items="breadItems"></bread-crumbs>
    </div>
    <v-card :loading="loading">
      <v-form id="AttendanceForm" ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container>
          <fieldset>
            <legend>Mark Attendance</legend>
            <v-row class="ml-minus-18">
              <v-col cols="12" sm="4" md="4">
                <v-date-picker
                :first-day-of-week="1"
                  elevation="15"
                  v-model="picker2"
                  color="green lighten-1"
                  header-color="primary"
                ></v-date-picker>
              </v-col>
              <v-col cols="12" sm="8" md="8">
                <v-row>
                  <v-col>
                    <label class="custom-label">Select Group Session</label>
                    <v-autocomplete
                      :error-messages="errors.group_session_id"
                      v-model="data.group_session_id"
                      :items="groups"
                      solo
                      label="Group Session"
                      placeholder="Group Session"
                      item-text="group.tutor.tutor_fname"
                      item-value="group_session_id"
                      @select="students = []"
                    >
                      <template slot="item" slot-scope="data">
                        {{ data.item.group_session_id }} -
                        {{ data.item.group.tutor.tutor_fname }}
                        {{ data.item.group.tutor.tutor_lname }}
                      </template>
                      <template slot="selection" slot-scope="data">
                        {{ data.item.group_session_id }} -
                        {{ data.item.group.tutor.tutor_fname }}
                        {{ data.item.group.tutor.tutor_lname }}
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <v-btn @click="getTeacher" :loading="loading" color="#6A158E" dark
                      >Submit</v-btn
                    >
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <table style="border: 1px solid lightgrey; width: 100%">
                  <tr style="text-align: left">
                    <th>Name</th>
                    <th>Hours</th>
                    <th style="width: 120px">Hours Attended</th>
                    <!-- <th style="" >Catchup</th> -->
                    <th>Notes</th>
                  </tr>
                  <tr v-for="(tutor, index) in tutors" :key="tutor.tutor_lname" style="">
                    <td>{{ tutor.tutor_fname }} {{ tutor.tutor_lname }}</td>
                    <td>{{ tutor.week_hours[today_day] }}</td>
                    <td>
                      <v-text-field
                        placeholder="Hours"
                        solo
                        type="number"
                        v-model="data[index].hours"
                        @input="checkValue(tutor.week_hours[today_day], data[index].hours)"
                      ></v-text-field>
                      <h6 v-if="time_larger">Hours Attended must be less then hours</h6>
                    </td>
                    <!-- <td style="">
                                        <p> <v-checkbox class="mx-2"
                                        v-model="data[index].catchup"
                                            :rules="[rules.max(tutor.week_hours[today_day],data[index].hours)]"
                                         ></v-checkbox></p>
                                  </td> -->
                    <td>
                      <v-textarea
                        height="20px"
                        placeholder="Notes"
                        class="ml-4"
                        solo
                        v-model="data[index].notes"
                        @click="checkValue(tutor.week_hours[today_day], data[index].hours)"
                      
                      ></v-textarea>
                    </td>
                  </tr>
                </table>
              </v-col>
            </v-row>
          </fieldset>

          <v-row>
            <v-col cols="12" v-if="showSaveButton">
              <v-btn
                @click="save"
                v-if="tutors.length > 0"
                :loading="loading"
                color="#6A158E"
                dark
                >Save</v-btn
              >
            </v-col>
            <v-col cols="12" v-else>
              <v-btn
                @click="save"
                v-if="tutors.length > 0"
                :loading="loading"
                color="#6A158E"
                dark
                >Update</v-btn
              >
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
import Form from "../../../utils/form";
import BreadCrumbs from "../../../components/BreadCrumbs";
import { getPermitObjects } from "../../../utils/allowedPermissions";
export default {
  name: "WorkForm",
  components: {
    BreadCrumbs,
  },
  props: {
    id: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      permitObj: {},
      showSaveButton: true,
      rules: {
        minValue(value, min) {
          return parseInt(value) >= parseInt(min);
        },
        required: (value) => !!value || "'This Field is required'",
        min(min, v) {
          return (v || "").length >= min || `Value must be at least ${min}`;
        },
        max(max, v) {
          return (v || "").length <= max || `Value may not be greater than ${max}.`;
        },
      },
      valid: true,
      lazy: false,
      overlay: false,
      page_title: this.$route.meta.title,
      breadItems: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
          to: {
            name: "DashBoard",
          },
        },
        {
          text: this.$route.meta.title,
          disabled: true,
          to: {
            name: this.$route.name,
          },
        },
      ],
      work_types: ["home", "class"],
      loading: false,
      type: [
        {
          value: "classes",
          text: "Class Work",
        },
        {
          value: "home",
          text: "Home Work",
        },
      ],
      filters: {},
      picker2: new Date().toISOString().substr(0, 10),
      data: {},
      errors: {},
      tutor_search: "",
      tutors: [],
      today_day: "",
      groups: [],
      group_search: "",
      tutor_work_hour: 0,
      time_larger : false,
    };
  },
  watch: {
    picker2: function (val) {
      // watch it
      //   alert(val)
      this.getSessions();
    },
  },
  methods: {
    getPermittedArray() {
      console.log(this.$store, 'this.$store from TeacherAttendance');
      let links = this.$store?.getters?.permissions;
      let pathName = "TeacherAttendance";
      this.permitObj = getPermitObjects(links, pathName)
    },
    getSessions() {
      axios
        .get("group/sessions", {
          params: {
            date: this.picker2,
            type: "teacher_attendance",
          },
        })
        .then((response) => {
          // console.log(response)
          // this.students = response.data.response
          this.groups = response.data.groups;
          // this.data.push(this.stud)
          // response.data.response.map((student,index) => {
          //     var array = {
          //         'id' : student.std_id,
          //         'hours' : '',
          //     }
          //     this.data[index] = array
          // })
        });
    },
    getTeacher() {
      if (typeof this.data.group_session_id == "undefined") {
        Toast.fire({
          icon: "error",
          title: "Please select a group session!",
        });
        return;
      }
      this.overlay = false;
      var filters = {
        picker2: this.picker2,
        session_id: this.data.group_session_id,
      };
      // this.students = [];
      axios
        .post("attendance/teachers", filters)
        .then((response) => {
          this.overlay = false;
          // console.log(response)
          if (response.data.response.length == 0) {
            Toast.fire({
              icon: "error",
              title: "No Students in this group session!",
            });
          }
          // this.groups = response.data.groups
          // this.data.push(this.stud)
          this.today_day = response.data.today_day;
          this.showSaveButton = true;
          response.data.response.map((tutor, index) => {
            if (tutor.week_hours == null) {
              Toast.fire({
                icon: "error",
                title: "Week hours not defied for one of the students in this group session!",
              });
              return false;
            }
            var array = {
              id: tutor.tutor_id,
              hours: 0,
              group_session_attendance_id: "",
            };
            this.tutor_work_hour = tutor.week_hours[response.data.today_day];
            this.data[index] = array;
            if (
              tutor.group_session_attendance != null &&
              tutor.group_session_attendance.length > 0
            ) {
              let group_session_attendance =
                tutor.group_session_attendance[tutor.group_session_attendance.length - 1];
              this.data[index].hours =
                group_session_attendance.hours != null
                  ? group_session_attendance.hours
                  : 0;
              this.data[index].notes =
                group_session_attendance.hours != ""
                  ? group_session_attendance.notes
                  : "";
              this.data[index].group_session_attendance_id =
                group_session_attendance.group_session_attendance_id;
              this.showSaveButton = false;
            }
          });
          // console.log(response.data.response)
          this.tutors = response.data.response;
        })
        .catch((error) => {
          this.overlay = false;
        });
    },
    checkSessionShouldSaveOrUpdate(group_session_id) {
      let found = false;
      this.groups.map((group, index) => {
        if (
          group.group_session_id == group_session_id &&
          group.session_attendance != null
        ) {
          found = true;
        }
      });
      if (found) {
        this.showSaveButton = false;
      } else {
        this.showSaveButton = true;
      }
    },
    create() {
      if (this.tutors.length == 0) {
        Toast.fire({
          icon: "error",
          title: "No students in the session!",
        });
        return;
      }
      if (parseInt(this.data[0].hours) > parseInt(this.tutor_work_hour)) {
        Toast.fire({
          icon: "error",
          title: "Attending Hour Must not be greater than actual hours",
        });
        return;
      }
      if (parseInt(this.data[0].hours) <= 0) {
        Toast.fire({
          icon: "error",
          title: "Attending Hour Must be greater than 0",
        });
        return;
      }
      this.loading = true;
      // let form = new Form({...this.data})
      var data = {
        group_session_id: this.data.group_session_id,
        data: this.data,
      };
      axios
        .post("save/teacher/attendance", data)
        .then((response) => {
          Toast.fire({
            icon: "success",
            title: "Attendance Saved",
          });
          this.loading = false;
          this.tutors = [];
          this.$refs.form.reset();
          this.getSessions();
        })
        .catch((response) => {
          if (response.status === 400) {
            this.errors = response.data;
          }
          // alert(response.status)
          if (response.status === 422) {
            //    console.log(response.data)
            this.errors = response.data.errors;
          }
          this.loading = false;
        });
    },
    save() {
      this.create();
    },
    checkValue(tutor_time, attendance_time){
      if(tutor_time < attendance_time){
        this.time_larger = true ;
      } else {
          this.time_larger = false ;
      
      }
    },
  },
  mounted() {
    this.getPermittedArray();
    // this.getStudents()
    this.getSessions();
    this.checkValue();
  },
};
</script>

<style lang="scss" scoped>
fieldset {
  border: 0;

  &:not(:last-of-type) {
    border-bottom: 1px dashed #8898aa80;
    margin-bottom: 20px;
  }

  & legend {
    font: Bold 20px/25px Lato;
    color: #172b4d;
  }
}

.page-heading {
  font: 300 22px/26px;
  font-family: "Gotham Narrow";
  color: #6a158e;
}
</style>
